export default __webpack_public_path__ + "d43fc888213dc868a338bd4063d478ae.svg";